export default "__VITE_ASSET__sqOh5LRA__"